import React from 'react';
import { log as yxLogger } from '@jd/yxlogtag';

import { goto } from '@/common/goto';
import { getRootPath } from '../../resource-detail/util';
import './index.less';
import { message } from '@drip/drip-design';

const prefix = 'pallet-inform';

interface IPalletInform {
  resourceId?: string;
  activityId?: string;
  channelHeadInfo?: { channelId: string; channelName: string };
  isDaily?: boolean;
  roomId?: string;
}
const NewPalletInform = (props: IPalletInform) => {
  const { resourceId, activityId, channelHeadInfo, roomId, isDaily } = props;
  return (
    <div className={`${prefix}-container`}>
      <div>
        <span>系统公告：</span> 在京东App 有固定频道露出或首页有推荐坑位的货盘上线啦，快去看看吧～
      </div>
      <span
        onClick={() => {
          if (isDaily) {
            goto(
              `/activity-manage/myCreate/daily-activities-manager/materials/rule-collection?activityId=${activityId}&roomId=${roomId}`,
              'push'
            );
            return;
          }
          if (!channelHeadInfo?.channelId || !resourceId) {
            message.info('缺少阵地资源位必要参数');
            return;
          }
          yxLogger?.(
            `view_marketing_pallet|||${JSON.stringify({
              channelId: channelHeadInfo?.channelId,
              channelName: channelHeadInfo?.channelName,
            })}`
          );
          goto(
            `/${getRootPath()}/resource-detail/material-collection/rule-selection?channelId=${
              channelHeadInfo?.channelId
            }&resourceId=${resourceId}&activityId=${activityId}`,
            'push'
          );
        }}
      >
        立即查看
      </span>
    </div>
  );
};

export default NewPalletInform;
